import gql from 'graphql-tag';

export const claimsByStatus = gql`
  query claimsByStatus($leaseId: String!, $status: String) {
    claimsByStatus(leaseId: $leaseId, status: $status) {
      claimId
      claimDate
      claimType
      total
      statusName
    }
  }
`;

export const saveClaim = gql`
  mutation saveClaim($payLoad: saveClaimPayload!) {
    saveClaim(payLoad: $payLoad) {
      status
    }
  }
`;
